import { render, staticRenderFns } from "./RidesPerSupplier.vue?vue&type=template&id=61b314fa&scoped=true&"
import script from "./RidesPerSupplier.vue?vue&type=script&lang=js&"
export * from "./RidesPerSupplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b314fa",
  null
  
)

export default component.exports